import { definePreset } from "@primeuix/themes"
import type { Preset } from "@primeuix/themes/types"
import MissonControlTheme, { McComponentDesignTokens } from  './themes/MissionControl'


export namespace Theme {



    const overrides: any = {
       


    }

    //You can switcth the type to ComponentsDesignTokens to get some intellisense help with the components, however, you can also add 
    // additional properties that don't exist and it will still update the css, so put it back to any when you're done.
    const componentOverrides: McComponentDesignTokens = {
        button: {
            root: {
                // paddingX: ".5rem",
                // paddingY: ".3rem"
            }
        },
        card: {
            body: {
                // padding: "1.5rem .5rem"
            },
            header: {
                
            },
            title: {
                // fontWeight: "500",
                // fontSize: "1.5rem",
                // marginBottom: ".4rem",
                // padding: "0 .5rem"
            }
        },
        splitter: {
            root: {
                // background: "#f3f3f4"
            }


        }
    }

    export const McTheme = definePreset(MissonControlTheme as Preset, {
        ...overrides,
        components: componentOverrides

    })

}